import React from 'react';
import UDText from '../text';

interface Props {
  children: React.ReactNode;
}

const UDHeaderTitle = (props: Props) => {
  return (
    <UDText type="headline" className="text-inkPrimary">
      {props.children}
    </UDText>
  );
};

export default UDHeaderTitle;
